import Grid from "@mui/material/Unstable_Grid2/Grid2"
import ProcuraEntregas from "./PeocuraEntregas/ProcuraEntregas"
import ListaAguardandoEntregas from "./ListaAguardandoEntregas/ListaAguardandoEntregas.jsx"
import LiberaAcessoEntregador from "./LiberaAcessoEntregador/LiberaAcessoEntregador.jsx"
import ListaEntregas from "./ListaEntregas/ListaEntregas"
import { containerCriaEntrega, containerEntregasTab, containerListaAguardando, containerListaEntregas, containerProcurarEntregas } from "./sxEntregasTab"
import CriarEncomenda from "./CriarEncomenda/CriarEncomenda.jsx"
import { Box, Typography } from "@mui/material"
import { containerListaAguardandoEntregas, styleIcon, styleTitulo, typografyListaAguardando } from "./ListaAguardandoEntregas/ListaAguardandoEntregas.js"
import MarkEmailReadOutlinedIcon from '@mui/icons-material/MarkEmailReadOutlined'

const EntregasTab = ({ ativoNavBar = false }) => {
    return (
        <Grid xs={12} sm={12} md={12} lg={12} xl={12} sx={{ ...containerEntregasTab, backgroundColor: ativoNavBar ? '#D9D9D9' : '' }}>
            <Grid xs={12} sm={12} md={12} lg={12} xl={12} sx={containerProcurarEntregas}>
                <ProcuraEntregas ativoNavBar={ativoNavBar}/>
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={12} xl={12} sx={containerCriaEntrega}>
                <CriarEncomenda />
            </Grid>
            <Grid xs={12} sm={12} md={12} lg={12} xl={12} sx={containerListaEntregas}>
                <ListaEntregas />
            </Grid>
            <Grid container xs={12} sm={12} md={12} lg={12} xl={12} sx={containerListaAguardando} >

                <Grid xs={7} sm={7} md={7} lg={ativoNavBar ? 12 : 7} xl={ativoNavBar ? 12 : 7} sx={{ borderRight: ativoNavBar ? '' : '1px solid white', height: '100%' }}>

                    <Box sx={styleTitulo}>
                        <MarkEmailReadOutlinedIcon sx={styleIcon}></MarkEmailReadOutlinedIcon>
                        <Typography sx={typografyListaAguardando}>Aguardando Recebimento</Typography>
                    </Box>
                    <Box sx={containerListaAguardandoEntregas}>
                        <ListaAguardandoEntregas />
                    </Box>
                </Grid>
                {
                    !ativoNavBar &&
                    <Grid xs={5} sm={5} md={5} lg={5} xl={5} sx={{ height: '100%', overflowY: 'auto', padding: '5px 4px' }}>
                        <LiberaAcessoEntregador></LiberaAcessoEntregador>
                    </Grid>
                }

            </Grid>
        </Grid>
    )
}

export default EntregasTab
